import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, GetAICoachGoalsResponse, UpdateAICoachGoalsParams } from 'api/AICoachGoalsApi';

export const createUpdateAICoachGoalsThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('yourGoal/updateAICoachGoals', async (params: UpdateAICoachGoalsParams, thunkApi) => {
    try {
      const updatedGoals: GetAICoachGoalsResponse = await api.updateAICoachGoals(params);
      return updatedGoals;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });
